/**
 * Living Roots - Carousel
 * Simple loop carousel - no autoplay, no clones
 * Arrows at bottom corners
 */

class LRCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('[data-carousel-track]');
    
    if (!this.track) return;
    
    this.items = Array.from(this.track.children);
    if (this.items.length === 0) return;
    
    // Find arrows - could be inside container or in sibling arrows container
    const section = container.closest('section');
    this.prevBtn = section.querySelector('[data-carousel-prev]');
    this.nextBtn = section.querySelector('[data-carousel-next]');
    
    this.currentIndex = 0;
    this.itemWidth = 0;
    this.gap = 0;
    this.visibleItems = 1;
    this.maxIndex = 0;
    
    this.init();
  }
  
  init() {
    this.calculateDimensions();
    this.bindEvents();
    
    // Recalculate on resize
    window.addEventListener('resize', () => {
      this.calculateDimensions();
      this.goTo(this.currentIndex, false);
    });
  }
  
  calculateDimensions() {
    const firstItem = this.items[0];
    const style = window.getComputedStyle(this.track);
    
    this.itemWidth = firstItem.offsetWidth;
    this.gap = parseInt(style.gap) || 16;
    
    const containerWidth = this.track.parentElement.offsetWidth;
    this.visibleItems = Math.floor(containerWidth / (this.itemWidth + this.gap)) || 1;
    this.maxIndex = Math.max(0, this.items.length - this.visibleItems);
  }
  
  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prev());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.next());
    }
    
    // Touch/swipe support
    let startX = 0;
    let currentX = 0;
    
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    
    this.track.addEventListener('touchmove', (e) => {
      currentX = e.touches[0].clientX;
    }, { passive: true });
    
    this.track.addEventListener('touchend', () => {
      const diff = startX - currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    });
  }
  
  next() {
    if (this.currentIndex >= this.maxIndex) {
      // At end, loop to start
      this.goTo(0);
    } else {
      this.goTo(this.currentIndex + 1);
    }
  }
  
  prev() {
    if (this.currentIndex <= 0) {
      // At start, loop to end
      this.goTo(this.maxIndex);
    } else {
      this.goTo(this.currentIndex - 1);
    }
  }
  
  goTo(index, animate = true) {
    this.currentIndex = index;
    const offset = index * (this.itemWidth + this.gap);
    
    this.track.style.transition = animate ? 'transform 0.4s ease' : 'none';
    this.track.style.transform = `translateX(-${offset}px)`;
  }
}

// Initialize all carousels on page load
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('[data-carousel-track]');
  carousels.forEach(track => {
    const container = track.closest('[data-carousel]') || track.parentElement;
    new LRCarousel(container);
  });
});
